import { useContext } from "react";
import { MobXProviderContext, observer } from "mobx-react";
import { toJS } from "mobx";

import CommonStore from "./commonStore";
import AuthStore from "./authStore";

const RootStore = {
  commonStore: new CommonStore(),
  authStore: new AuthStore(),
};

function useStores() {
  return useContext(MobXProviderContext);
}

export { RootStore };
export default useStores;
export { observer };
export { toJS };
